function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
export default (function (_ref) {
  var colors = _ref.colors,
    mediaQueries = _ref.mediaQueries;
  return {
    base: _defineProperty({
      display: 'none',
      marginRight: '-110px',
      padding: '7px 6px',
      float: 'left',
      background: colors.secondary,
      borderRadius: '4px',
      color: colors.white,
      textDecoration: 'none',
      fontSize: '11px',
      lineHeight: '16px'
    }, mediaQueries.breakpointTablet, {
      display: 'inline-block'
    })
  };
});